import { PieChartOutlined } from "@ant-design/icons";
// import UserUser from "../menus/user";
import { GrBike, GrNotification } from "react-icons/gr";
import { GiCook } from "react-icons/gi";
import { FaUsers, FaListAlt } from "react-icons/fa";
import { AiFillShop, AiFillSetting } from "react-icons/ai";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { BiFoodMenu, BiStats } from "react-icons/bi";
import { BiHelpCircle } from "react-icons/bi";

import Support from "../menus/support";

import Profil from "../menus/profil";

import Dashboard from "../menus/dashboard";
import GloceryArticle from "../menus/glocery-article";
import OrderGlocery from "../menus/order-glocery";
import WithdrawalWithdrawal from "../menus/withdrawal";

const list_menu = [
  {
    value: "dashboard",
    icon: <PieChartOutlined />,
    title: "Dashboard",
    url: "/main",
    component: Dashboard
  },
  {
    value: "glocery",
    icon: <AiFillShop />,
    title: "My shop",
    url: "/main/glocery",
    children: [
      {
        value: "glocery-item",
        title: "Articles",
        url: "/main/glocery/item",
        component: GloceryArticle
      },
      {
        value: "glocery-order",
        title: "Orders",
        url: "/main/order/list",
        component: OrderGlocery
      },
      {
        value: "chef-withdrawal",
        title: "Withdrawals",
        url: "/main/chef/withdrawal",
        component: WithdrawalWithdrawal
      }
    ]
  },

  {
    value: "support",
    icon: <BiHelpCircle />,
    title: "Support",
    url: "/main/support",
    component: () => <Support type="partner" />
  },
  {
    value: "setting",
    icon: <AiFillSetting />,
    title: "Profil",
    url: "/main/profil",
    component: Profil
  }
];

export { list_menu };
